import { watch } from "vue";

export function useFilterDebounce(searchRef, callback, delay = 300) {
  let timer = null;
  watch(searchRef, (val) => {
    clearTimeout(timer);
    timer = setTimeout(() => callback(val), delay);
  });

  function searchNow() {
    clearTimeout(timer);
    callback(searchRef.value);
  }

  return { searchNow };
}
